import { Component, signal, Signal } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent {
  currentYear: Signal<number> = signal(new Date().getFullYear());
}
